/**
 * Environment variable configuration
 * Type-safe access to environment variables
 */

export const env = {
  // GraphQL Configuration
  graphqlEndpoint: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT || '/graphql/v1',

  // API Configuration
  apiUrl: process.env.NEXT_TAG_SERVICE_API_URL || 'http://localhost:3001',

  // MTag Service WebSocket (direct connection, bypasses BFF)
  mtagWsEndpoint:
    process.env.NEXT_PUBLIC_MTAG_WS_ENDPOINT ||
    'ws://localhost:8080/ws/dashboard',

  // Environment
  environment: (process.env.NEXT_PUBLIC_ENVIRONMENT || 'development') as
    | 'development'
    | 'staging'
    | 'production',

  // Utility
  isDevelopment: process.env.NEXT_PUBLIC_ENVIRONMENT === 'development',
  isProduction: process.env.NEXT_PUBLIC_ENVIRONMENT === 'production',
  isStaging: process.env.NEXT_PUBLIC_ENVIRONMENT === 'staging',
}
